import React, { useState, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { business } from '../data/siteData';
import Logo from './Logo';

const links = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/services', label: 'Services' },
  { to: '/service-area', label: 'Service Area' },
  { to: '/gallery', label: 'Gallery' },
  { to: '/contact', label: 'Contact' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      {/* Top bar */}
      <div className="hidden md:block bg-slate-900 text-slate-200 text-sm">
        <div className="max-w-7xl mx-auto px-6 py-2 flex justify-between">
          <span className="text-amber-400 font-medium tracking-wide">
            {business.tagline} · {business.subTagline}
          </span>
          <a href={`tel:${business.phoneRaw}`} className="flex items-center gap-2 hover:text-amber-400 transition-colors">
            <Phone size={14} /> {business.phone}
          </a>
        </div>
      </div>

      <header
        className={`sticky top-0 z-50 transition-all duration-300 ${
          scrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group">
            <div className="shrink-0 group-hover:rotate-3 transition-transform">
              <Logo size={48} variant="light" />
            </div>
            <div className="leading-tight">
              <div className="font-extrabold text-slate-900 text-lg tracking-tight">MW Stewart</div>
              <div className="text-[11px] uppercase tracking-[0.18em] text-amber-600 font-semibold">Construction</div>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === '/'}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-md text-sm font-semibold tracking-wide transition-colors ${
                    isActive
                      ? 'text-amber-600 bg-amber-50'
                      : 'text-slate-700 hover:text-amber-600 hover:bg-amber-50'
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <a
            href={`tel:${business.phoneRaw}`}
            className="hidden lg:inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-600 text-slate-900 font-bold px-5 py-2.5 rounded-md shadow-md hover:shadow-lg transition-all"
          >
            Get a Free Quote
          </a>

          <button
            onClick={() => setOpen(!open)}
            className="lg:hidden p-2 text-slate-900"
            aria-label="Toggle menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>

        {open && (
          <div className="lg:hidden border-t border-slate-200 bg-white">
            <div className="px-6 py-4 flex flex-col gap-1">
              {links.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  end={l.to === '/'}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `px-3 py-3 rounded-md font-semibold ${
                      isActive ? 'text-amber-600 bg-amber-50' : 'text-slate-800 hover:bg-slate-50'
                    }`
                  }
                >
                  {l.label}
                </NavLink>
              ))}
              <a
                href={`tel:${business.phoneRaw}`}
                className="mt-2 inline-flex items-center justify-center gap-2 bg-amber-500 text-slate-900 font-bold px-5 py-3 rounded-md"
              >
                <Phone size={16} /> {business.phone}
              </a>
            </div>
          </div>
        )}
      </header>
    </>
  );
}
